//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import bankEmployeeStore from '@/store/modules/bankEmployeeStore';
import customerStore from '@/store/modules/customerStore';
import configStore from '@/store/modules/configStore';
import ApiClient from '@/api/_apiClient';
import AcceptCheckboxInvite from '@/components/customer/invite/AcceptCheckboxInvite';
import BankingLoginInvite from '@/components/customer/invite/BankingLoginInvite.vue';
import CredentialInvite from '@/components/customer/invite/CredentialInvite';
import TechnicalMessages from '@/components/core/TechnicalMessages';
import BankChooserDialog from '@/components/customer/dialog/BankChooserDialog.vue';

export default {
    components: { TechnicalMessages, BankingLoginInvite, CredentialInvite, AcceptCheckboxInvite },
    data() {
        return {
            tab: 'bankingLogin',
            accept: false,
        };
    },
    computed: {
        bankingLoginActive() {
            return this.config.customer.basActive || this.config.customer.yesActive;
        },
        ...configStore.mapState({
            config: configStore.STATE.CONFIG,
        }),
    },
    methods: {
        async initBankingLogin() {
            try {
                await bankEmployeeStore.dispatch(bankEmployeeStore.ACTIONS.LOGOUT);

                let initUrl = '/_yes/register-with-invitation-code';
                let issuerUrl = null;

                if (this.config.customer.basActive) {
                    initUrl = '/_bas/register-with-invitation-code';

                    if (!this.config.customer.skipBasBankChooser) {
                        let cancel = false;
                        const { data } = await ApiClient.get('/_bas/bank-chooser', { baseURL: '' });

                        await new Promise((resolve) => {
                            this.$q.dialog({
                                component: BankChooserDialog,
                                data: data,
                                parent: this,
                            }).onOk(async (selectedEntry) => {
                                issuerUrl = selectedEntry.issuerUrl;
                                resolve();
                            }).onCancel(() => {
                                cancel = true;
                                resolve();
                            });
                        });

                        if (cancel) {
                            return;
                        }
                    }
                }

                this.$q.loading.show();

                const { data } = await ApiClient.get(initUrl, {
                    baseURL: '',
                    params: {
                        'invitation-code': this.$route.params.invitationCode,
                        'issuer-url': issuerUrl || undefined,
                    },
                });

                window.location.href = data.url;
            } catch (error) {
                this.$root.$handleError(error);
            } finally {
                this.$q.loading.hide();
            }
        },
        async submit(password) {
            this.$q.loading.show();
            try {
                await bankEmployeeStore.dispatch(bankEmployeeStore.ACTIONS.LOGOUT);
                await customerStore.dispatch(customerStore.ACTIONS.REGISTER_WITH_INVITATION_CODE, {
                    invitationCode: this.$route.params.invitationCode,
                    password,
                });
                await this.$router.push({ name: 'customer-dashboard' });
            } catch (error) {
                this.$handleError(error);
            }
            this.$q.loading.hide();
        },
    },
    async beforeRouteEnter(to, from, next) {
        if (customerStore.getters[customerStore.GETTERS.IS_LOGGED_IN]) {
            return next({ name: 'customer-dashboard' });
        }

        if (configStore.state[configStore.STATE.CONFIG]?.customer?.closedRegistration === false) {
            // TODO: implement open registration
            // return next({ name: 'customer-registration' });
        }

        if (to.query['yes-error'] !== undefined) {
            return next(vm => {
                vm.$router.replace({ name: 'customer-invite' });
                const message = to.query['yes-error'] || 'Bei der Registrierung mit Ihrer Bank ist ein Fehler aufgetreten.';
                vm.$notify(message, 'negative', 'top', { timeout: 30000 });
            });
        }

        if (to.query['bas-error'] !== undefined) {
            return next(vm => {
                vm.$router.replace({ name: 'customer-invite' });
                const message = to.query['bas-error'] || 'Bei der Registrierung mit Ihrer Bank ist ein Fehler aufgetreten.';
                vm.$notify(message, 'negative', 'top', { timeout: 30000 });
            });
        }

        next();
    },
};
